import React, { useEffect, useState } from 'react'
//import { Document, Page, Text, View} from '@react-pdf/renderer'
import { Page, Document, StyleSheet, Text,View , Image} from '@react-pdf/renderer';
import { HoraActual, calcularEdad, fechaActual } from '../../../hooks/UseDate';
import { postInformacionEmpresa } from '../../../services/PaginaRuta';
import logo from '../../../images/Logo-G-Ocho.png';

const ModalDescargarPDFSuministrosDevueltosQxFarmacia = ({informePDFDevoluciones,dataDevolucionesPDF,item,dataInconsistencias,devolucionBodega,noHayRelacionesEntreBodegas,noHayCanitdadesADevolver,PDFDevoluciones}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [informacionEmpresa, setinformacionEmpresa]=useState([])
  useEffect(()=>{
    const datosEmpresa={
      "EMPCOD":usuarioInfo.Empresa,
      "MCDpto":usuarioInfo.Sede
  }
  postInformacionEmpresa(datosEmpresa).then((res)=>{
    setinformacionEmpresa(res.data[0]) 
  })
  },[])
  //styles
  const styles = StyleSheet.create({
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none", 
      //borderWidth: 1, 
      //borderRightWidth: 0, 
      // borderBottomWidth: 0 
    }, 
    tableRow: { 
      //margin: "auto", 
      flexDirection: "row" 
    }, 
    tableCol: { 
      width: "16.6%", 
      borderStyle: "none", 
      //borderWidth: 1, 
      //borderLeftWidth: 0, 
      //borderTopWidth: 0 
    }, 
    tableCell: { 
      width: "10%",
      padding: '3px',
      //flexGrow: 1,
      //margin: "auto", 
      //marginTop: 2, 
      fontSize: 7 
    },
    body:{
      padding: '10px'
    },
    tableCellLarge:{
      width: "50%",
      padding: '3px',
      //flexGrow: 1,
      //margin: "auto", 
      //marginTop: 2, 
      fontSize: 7 
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 60, 
      height: 60, 
      margin: '10px',
    },
  });
  // const styles2 = StyleSheet.create({
  //   table: {
  //     display: 'table',
  //     width: 'auto',
  //     borderStyle: 'none',
  //   },
  //   row: {
  //     flexDirection: 'row',
  //   },
  //   cell: {
  //     flexGrow: 1,
  //   },
  //   cellLarge: {
  //     flexGrow: 5,
  //   },
  // });
  return (
    <Document>
            
            <Page style={styles.body}>
            <View>
            <Image style={styles.image} src={logo} />
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpNit}</Text>
                <Text style={{textAlign: 'center', fontWeight: 'bold',fontSize: 10, lineHeight: 2,padding: '3px' }}>DEVOLUCION DE FARMACIA</Text>
                {/* <Text style={{lineHeight: 1,fontSize: 12, padding: '5px'}}>DATOS PERSONALES</Text> */}
              </View>
              <View style={{padding: '10px'}}>
                <Text style={{fontSize: 8}}>Fecha: {fechaActual()}   Hora: {HoraActual()}</Text>
                <Text style={{fontSize: 8}}>Paciente: {item.MPNOMC? item.MPNOMC.trim():null}    {item.MPCedu? item.MPCedu.trim():null}</Text>
                <Text style={{fontSize: 8}}>Empresa: {item.ProEPS? item.ProEPS:null}      Sexo: {item.MPSexo? item.MPSexo:null}     Edad: {calcularEdad(item.MPFchN.split(" ")[0])}</Text>
                <Text style={{fontSize: 8}}>Paquete QX: {item.PaqCod? item.PaqCod:null}-{item.PaqDes? item.PaqDes:null}</Text>
              </View>
              
              
                
                <View style={styles.table}> 
                <View style={styles.tableRow}> 
                  <View style={styles.tableCell}> 
                    <Text >Codigo</Text> 
                  </View> 
                  <View style={styles.tableCellLarge}> 
                    <Text >Descripción</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cant solici</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cant despa</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cant usada</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >Cant devuelta</Text> 
                  </View> 
                </View>
                {PDFDevoluciones.map((row,index) => (
                <View style={styles.tableRow} key={index}> 
                  <View style={styles.tableCell}> 
                    <Text >{row.MSRESO}</Text> 
                  </View> 
                  <View style={styles.tableCellLarge}> 
                    <Text >{row.MSNomG? row.MSNomG.trim():null}</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >{row.PQCaSuSl}</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >{row.PQCaSuDs}</Text> 
                  </View> 
                  <View style={styles.tableCell}>
                    <Text >{row.PQCaSuUs}</Text> 
                  </View>
                  <View style={styles.tableCell}> 
                  <Text>
                    {(() => {
                      const ds = parseInt(row.PQCaSuDs);
                      const us = parseInt(row.PQCaSuUs);
                      //if(row.NoHayRelacionBodegas === "si hay relaciones entre bodegas"){
                        if (isNaN(ds) || isNaN(us)) {
                          return row.PQCaSuDs;
                        } else {
                          return `${ds - us}.0000`;
                        }
                      // }else{
                      //   return row.PQCaSuDs
                      // }
                      
                    })()}
                    
                    </Text>

                  </View> 
                </View>                 
                ))
                }
                {noHayCanitdadesADevolver.map((row,index) => (
                <View style={styles.tableRow} key={index}> 
                  <View style={styles.tableCell}> 
                    <Text >{row.MSRESO}</Text> 
                  </View> 
                  <View style={styles.tableCellLarge}> 
                    <Text >{row.MSNomG? row.MSNomG.trim():null}</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >{row.PQCaSuSl}</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text >{row.PQCaSuDs}</Text> 
                  </View> 
                  <View style={styles.tableCell}>
                    <Text >{row.PQCaSuUs}</Text> 
                  </View>
                  <View style={styles.tableCell}> 
                  <Text>
                    {(() => {
                      const ds = parseInt(row.PQCaSuDs);
                      const us = parseInt(row.PQCaSuUs);
                      // if(row.NoHayRelacionBodegas === "si hay relaciones entre bodegas"){
                        if (isNaN(ds) || isNaN(us)) {
                          return row.PQCaSuDs;
                        } else {
                          return `${ds - us}.0000`;
                        }
                      // }else{
                      //   return '0.0000'
                      // }
                      
                    })()}
                    
                    </Text>

                  </View> 
                </View>                 
                ))
                }
                </View>
            </Page>
            <Page size='A4' style={{padding: '50px' }}>
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>{informacionEmpresa.EmpNit}</Text>
              <Text style={{ fontSize: 10,textAlign: 'center',padding: '3px'}}>INCONSISTENCIAS EN DEVOLUCIONES DE CIRUGÍA</Text>            
              {
                noHayRelacionesEntreBodegas.map((item, index) => (
                  item.NoHayRelacionBodegas !== "si hay relaciones entre bodegas" &&
                  <Text style={{ fontSize: 8, padding: '2px'}} key={index}>*{item.NoHayRelacionBodegas}</Text>
                ))
              }
                {
                  noHayCanitdadesADevolver.map((item,index)=>(
                    <Text style={{ fontSize: 8, padding: '2px'}} key={index}>*{item.mensaje}</Text>
                  ))
                }
            </Page>
            
    </Document>        
  )
}

export default ModalDescargarPDFSuministrosDevueltosQxFarmacia